import { memo, useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../component/button";
import { json, useNavigate } from "react-router-dom";
import { toastMsg } from "../component/toast";
import { AppContext } from "../context/AppContext";
import { ApiConfig } from "../Api/ApiConfig";
import { PostCallWithErrorResponse } from "../Api/ApiServices";

const MessageBox = memo((props) => {

    const { adminData } = useContext(AppContext)

    const { message, setIsOpen, isOpen, closeOnOutClick = true } = props


    return (
        <>
            <Modal show={isOpen}
                onHide={() => closeOnOutClick && setIsOpen(false)}
                centered
                size="md"
                dialogClassName="modal-h-650"
                style={{ zIndex: 2000 }}
                backdropClassName="message-box-backdrop">
                <Modal.Body>
                    {
                        props.children
                    }
                </Modal.Body>
            </Modal>
        </>
    )

})

export default MessageBox